import React from 'react'
import './Footer.css'

const Footer = () => {
	const lastUpdated = process.env.REACT_APP_LAST_UPDATED
        ? new Date(process.env.REACT_APP_LAST_UPDATED).toLocaleDateString(
            "en-US",
            {
                year: "numeric",
                month: "long",
                day: "numeric"
            }
        )
        : "Unknown";

	return (
		<footer>
			<span className='reserved'>
				© {new Date().getFullYear()} Bazgour Yassine, All rights reserved. <br/>
				<span className='last-updated'>Last updated: {lastUpdated}</span>
			</span>
			<div className='contact-icons'>
				<i onClick={() => {window.open('https://www.linkedin.com/in/yassine-bazgour-178b73305/', '_blank')}} className='contact-icon linkedin fab fa-linkedin'></i>
				<i onClick={() => {window.open('https://github.com/DarttGoblin', '_blank')}} className='contact-icon github fab fa-github'></i>
				<i onClick={() => {window.open('https://www.instagram.com/yassine_bazgour/', '_blank')}} className='contact-icon instagram fab fa-instagram'></i>
				<i onClick={() => {window.open('https://web.facebook.com/yassine.bazgour.5/', '_blank')}} className='contact-icon facebook fab fa-facebook'></i>
			</div>
		</footer>
	)
}

export default Footer